import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

const jsonHeaders = { 'Content-Type': 'application/json' };

const getDocuments = async () => {
  try {
    return await customFetch(API_ENDPOINTS.DOCUMENTS, { method: 'GET', headers: jsonHeaders });
  } catch (error) {
    console.error('書面一覧取得エラー:', error);
    throw error;
  }
};

const getPending = async () => {
  try {
    return await customFetch(API_ENDPOINTS.DOCUMENTS_PENDING, { method: 'GET', headers: jsonHeaders });
  } catch (error) {
    console.error('再署名対象取得エラー:', error);
    throw error;
  }
};

const getCurrent = async (docKey) => {
  try {
    return await customFetch(API_ENDPOINTS.DOCUMENT_CURRENT(docKey), { method: 'GET', headers: jsonHeaders });
  } catch (error) {
    console.error('書面取得エラー:', error);
    throw error;
  }
};

const getVersions = async (docKey) => {
  try {
    return await customFetch(API_ENDPOINTS.DOCUMENT_VERSIONS(docKey), { method: 'GET', headers: jsonHeaders });
  } catch (error) {
    console.error('バージョン履歴取得エラー:', error);
    throw error;
  }
};

const getVersion = async (docKey, version) => {
  try {
    return await customFetch(API_ENDPOINTS.DOCUMENT_VERSION(docKey, version), { method: 'GET', headers: jsonHeaders });
  } catch (error) {
    console.error('書面バージョン取得エラー:', error);
    throw error;
  }
};

const publishVersion = async (docKey, payload) => {
  try {
    return await customFetch(API_ENDPOINTS.DOCUMENT_VERSIONS(docKey), {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload)
    });
  } catch (error) {
    console.error('書面公開エラー:', error);
    throw error;
  }
};

export const documentService = {
  getDocuments,
  getPending,
  getCurrent,
  getVersions,
  getVersion,
  publishVersion
};
